import styled, { keyframes } from "styled-components";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import Modal from "../../../Componentes/Utils/Modal";
import { useEffect, useMemo, useState } from "react";
import Tabela2 from "../../../Componentes/Utils/Tabela2";
import axios from "axios";
import { formatarData } from "../../../Funcoes/FormatarData";
import GenericHeader from "../../../Componentes/GenericHeader";
import Filters from "../../../Componentes/Utils/Filters";
import ModalEditInvestigacao from "./ModalEditInvestigacao";
import { useModal } from "../../../contexts/ModalContext";
import MultiselectCheck from "../../../Componentes/Utils/MultiselectCheck";
import FilterContainer from "../../../Componentes/Utils/FilterContainer";
import { BsFiletypePdf } from "react-icons/bs";
import { TbLoader2 } from "react-icons/tb";
import { saveAs } from "file-saver";

const spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`

const Container = styled.div`
    width: 100%;
    flex-grow: 1;
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    border-radius: 5px;
`
const CelulaBody = styled.td`
    white-space: nowrap;
`
const IconePdf = styled(BsFiletypePdf)`
    width: 22px;
    height: 22px;
    color: #d9534f;
    cursor: pointer;
`
const IconeLoading = styled(TbLoader2)`
    width: 22px;
    height: 22px;
    color: #666;
    animation: ${spin} 1s linear infinite;
`

const Content = () => {

    const { isModalOpen, openModal, closeModal } = useModal();

    const [selectedInvestigacao, setSelectedInvestigacao] = useState(null);

    const [loading, setLoading] = useState(false);

    const [ downloadingIds, setDownloadingIds ] = useState([]);

    const [investigacoes, setInvestigacoes] = useState([]);
    const [investigacoesFiltradas, setInvestigacoesFiltradas] = useState([]);

    const fetchData = async () => {

        setLoading(true);

        try {

            const { data } = await axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/GetInvestigacoes/", {
                withCredentials: true
            });

            setInvestigacoes(data);
            setInvestigacoesFiltradas(data);

            console.log(data);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {

        fetchData();

    }, []);

    const openModalEdit = (obj) => {

        setSelectedInvestigacao(obj);
        openModal("modalEditInvestigacao");

    }

    const closeModalEdit = () => {

        setSelectedInvestigacao(null);
        closeModal();

    }

    const optionObras = useMemo(() => [...new Set(investigacoes.map((obj) => obj.centro_custo))].sort(), [investigacoes]).filter(cc => cc && cc.trim() !== "");
    const optionContratos = useMemo(() => [...new Set(investigacoes.map((obj) => obj.contrato))].sort(), [investigacoes]).filter(c => c && c.trim() !== "");
    const optionUsuarios = useMemo(() => [...new Set(investigacoes.map((obj) => obj.usuario))].sort(), [investigacoes]).filter(u => u && u.trim() !== "");

    const [ selectedObras, setSelectedObras ] = useState([]);
    const [ selectedContratos, setSelectedContratos ] = useState([]);
    const [ selectedUsuarios, setSelectedUsuarios ] = useState([]);
    const [ selectedClassificacoes, setSelectedClassificacoes ] = useState([]);
    const [ selectedResolucoes, setSelectedResolucoes ] = useState([]);

    const [ dataInicio, setDataInicio ] = useState(null);
    const [ dataFim, setDataFim ] = useState(null);

    useEffect(() => {

        let filtered = investigacoes;

        if( selectedObras.length > 0 ){ filtered = filtered.filter( inv => selectedObras.includes( inv.centro_custo ) ); }
        if( selectedContratos.length > 0 ){ filtered = filtered.filter( inv => selectedContratos.includes( inv.contrato ) ); }
        if( selectedUsuarios.length > 0 ){ filtered = filtered.filter( inv => selectedUsuarios.includes( inv.usuario ) ); }
        if( selectedClassificacoes.length > 0 ){ filtered = filtered.filter( inv => selectedClassificacoes.includes( inv.classificacao ) ); }
        if( selectedResolucoes.length > 0 ){ filtered = filtered.filter( inv => selectedResolucoes.includes( inv.resolvido ) ); }

        if( dataInicio ){
            const inicio = new Date( dataInicio );
            filtered = filtered.filter( inv => {
                if( !inv.data_ocorrido ) return false;
                const dataInv = new Date( inv.data_ocorrido );
                return dataInv >= inicio;
            });
        }
        if( dataFim ){
            const fim = new Date( dataFim );
            filtered = filtered.filter( inv => {
                if( !inv.data_ocorrido ) return false;
                const dataInv = new Date( inv.data_ocorrido );
                return dataInv <= fim;
            });
        }

        setInvestigacoesFiltradas( filtered );

    }, [ selectedObras, selectedContratos, selectedUsuarios, selectedClassificacoes, selectedResolucoes, dataInicio, dataFim, investigacoes ]);


    const generatePDF = async ( item, e ) => {
        e.stopPropagation();

        setDownloadingIds( prev => ([ ...prev, item.id ]) );

        try{

            const { data } = await axios.post("https://sistemaintegrado.palmont.com.br/Painel/Desvios/Investigacao/assets/php/generate_pdf.php", {
                id: item.id
            }, {
                responseType: 'blob',
                withCredentials: true
            });
            
            const blob = new Blob( [ data ], { type: 'application/pdf' } );
            saveAs( blob, `investigacao_${item.id}.pdf` );

        }catch(error){
            console.log(error);
        }finally{
            setDownloadingIds( prev => prev.filter( id => id !== item.id ) );
        }

    }

    return (
        <>
            <GenericHeader>
                <Filters columns={4} >
                    <MultiselectCheck
                        options={optionObras.map(cc => ({ label: cc, value: cc }))}
                        selectedOptions={selectedObras}
                        setSelectedOptions={setSelectedObras}
                        placeholder="CENTRO CUSTO"
                    />
                    <MultiselectCheck
                        options={optionContratos.map(c => ({ label: c, value: c }))}
                        selectedOptions={selectedContratos}
                        setSelectedOptions={setSelectedContratos}
                        placeholder="CONTRATO"
                    />
                    <MultiselectCheck
                        options={optionUsuarios.map(u => ({ label: u, value: u }))}
                        selectedOptions={selectedUsuarios}
                        setSelectedOptions={setSelectedUsuarios}
                        placeholder="PREENCHIDO"
                    />
                    <MultiselectCheck
                        options={[
                            { label: 'AAM', value: 'AAM' },
                            { label: 'ACA', value: 'ACA' },
                            { label: 'ASA', value: 'ASA' },
                            { label: 'INCIDENTE', value: 'INCIDENTE' },
                            { label: 'NRT', value: 'NRT' },
                            { label: 'SAA', value: 'SAA' }
                        ]}
                        selectedOptions={selectedClassificacoes}
                        setSelectedOptions={setSelectedClassificacoes}
                        placeholder="CLASSIFICAÇÃO"
                    />
                    <MultiselectCheck
                        options={[
                            { value: 0, label: 'PENDENTE' },
                            { value: 1, label: 'RESOLVIDO' }
                        ]}
                        selectedOptions={selectedResolucoes}
                        setSelectedOptions={setSelectedResolucoes}
                        placeholder="RESOLUÇÃO"
                    />
                    <MultiselectCheck
                        options={[]}
                        selectedOptions={[]}
                        setSelectedOptions={() => { }}
                        placeholder="ACIDENTADO"
                    />
                    <FilterContainer
                        type="date"
                        valor={ dataInicio }
                        changeFunc={( valor ) => { setDataInicio( valor )}}
                    />
                    <FilterContainer
                        type="date"
                        valor={ dataFim }
                        changeFunc={( valor ) => { setDataFim( valor )}}
                    />
                </Filters>
            </GenericHeader>
            <Container>
                {
                    loading ?
                        <Modal size="sm" >
                            <SmallLoading />
                        </Modal>
                        :
                        <>
                            <Tabela2>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>ID DESVIO</th>
                                        <th>CENTRO CUSTO</th>
                                        <th>CONTRATO</th>
                                        <th>PREENCHIDO</th>
                                        <th>CLASSIFICAÇÃO</th>
                                        <th>DATA</th>
                                        <th>RESOLUÇÃO</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        investigacoesFiltradas.map((item, index) => (
                                            <tr key={index}
                                                onClick={() => openModalEdit(item)}
                                            >
                                                <CelulaBody>{item.id}</CelulaBody>
                                                <CelulaBody>{item.id_desvio}</CelulaBody>
                                                <CelulaBody>{item.centro_custo}</CelulaBody>
                                                <CelulaBody>{item.contrato}</CelulaBody>
                                                <CelulaBody>{item.usuario ? item.usuario : "-"}</CelulaBody>
                                                <CelulaBody>{item.classificacao ? item.classificacao : "-"}</CelulaBody>
                                                <CelulaBody>{item.data_ocorrido ? formatarData(item.data_ocorrido) : "-"}</CelulaBody>
                                                <CelulaBody>{item.resolvido === 1 ? "RESOLVIDO" : "PENDENTE"}</CelulaBody>
                                                <CelulaBody>
                                                    {
                                                        downloadingIds.includes( item.id ) ? (
                                                            <IconeLoading />
                                                        ) : (
                                                            <IconePdf
                                                                title="Gerar PDF"
                                                                onClick={(e) => generatePDF(item, e)}
                                                            />
                                                        )
                                                    }
                                                </CelulaBody>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Tabela2>
                        </>
                }
            </Container>
            {
                isModalOpen("modalEditInvestigacao") && (
                    <ModalEditInvestigacao
                        fecharModal={closeModalEdit}
                        obj={selectedInvestigacao}
                        update={fetchData}
                    />
                )
            }
        </>
    )
}

export default Content;